import * as PropTypes from "prop-types";

import * as React from "react";
import { Modal, Button } from "react-bootstrap";
import * as _ from "lodash";

type Props = {
    abort?: () => void;
    confirm: () => void;
    onClose: () => void;
    show: boolean;
    abortBtn: React.ReactNode;
    confirmBtn: React.ReactNode;
    message: React.ReactNode;
};

class ConfirmModal extends React.Component<Props> {
    static propTypes = {
        abort: PropTypes.func,
        confirm: PropTypes.func,
        onClose: PropTypes.func,
        show: PropTypes.bool,
        abortBtn: PropTypes.node,
        confirmBtn: PropTypes.node,
        message: PropTypes.node
    };

    static Trigger: typeof ConfirmModalTrigger;

    abort = () => {
        if (this.props.abort && _.isFunction(this.props.abort)) {
            this.props.abort();
        }
        this.props.onClose();
        return false;
    };

    confirm = () => {
        if (_.isFunction(this.props.confirm)) {
            this.props.confirm();
        }
        this.props.onClose();
        return false;
    };

    render() {
        return (
            <Modal keyboard animation onHide={this.props.onClose} show={this.props.show}>
                <Modal.Header className="ex-confirm-modal" closeButton>
                    <Modal.Title>{this.props.message}</Modal.Title>
                </Modal.Header>
                <Modal.Footer>
                    <Button onClick={this.abort} data-selenium="ex-button-ignore">
                        {this.props.abortBtn}
                    </Button>
                    <Button onClick={this.confirm} bsStyle="primary" data-selenium="ex-button-confirm">
                        {this.props.confirmBtn}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

type TriggerState = {
    showModal: boolean;
};

type TriggerProps = {
    abort?: () => void;
    confirm: () => void;
    abortBtn: React.ReactNode;
    confirmBtn: React.ReactNode;
    message: React.ReactNode;
    children?: React.ReactNode;
};

class ConfirmModalTrigger extends React.Component<TriggerProps, TriggerState> {
    static propTypes = {
        abort: PropTypes.func,
        confirm: PropTypes.func,
        abortBtn: PropTypes.node,
        confirmBtn: PropTypes.node,
        message: PropTypes.node,

        children: PropTypes.node
    };

    state = { showModal: false };

    close = () => {
        this.setState({ showModal: false });
    };

    open = () => {
        this.setState({ showModal: true });
    };

    render() {
        return (
            <>
                <span onClick={this.open}>{this.props.children}</span>
                {this.state.showModal && (
                    <ConfirmModal
                        show
                        onClose={this.close}
                        confirm={this.props.confirm}
                        abort={this.props.abort}
                        message={this.props.message}
                        abortBtn={this.props.abortBtn}
                        confirmBtn={this.props.confirmBtn}
                    />
                )}
            </>
        );
    }
}

ConfirmModal.Trigger = ConfirmModalTrigger;

export default ConfirmModal;
export { ConfirmModalTrigger as Trigger };
